import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SparkleIconWhite } from '@ui/general';
import { useAnalysisPeriscope } from '@hooks';

export interface AiExplainButtonProps {
	hidden?: boolean;
	sonarObjectId: number;
}

export const AiExplainButton: React.FC<AiExplainButtonProps> = ({ hidden, sonarObjectId }) => {
	const { open } = useAnalysisPeriscope();

	return (
		<FeatureBoundary feature={ FeatureFlag.AIWorkflowApexClass }>
			<Button
				className='apex-class-ai-explain-button'
				icon={ <SparkleIconWhite /> }
				onClick={ () => open(sonarObjectId, SonarObjectType.SalesforceApexClass) }
				style={ { display: hidden ? 'none' : 'inline-flex' } }
				type='primary'>
				{ COPY_SPECIFIC.AI_EXPLAIN }
			</Button>
		</FeatureBoundary>
	);
};
